<template>
  <v-container
    id="IframeOrdini"
    tag="section"
  >
    <iFrame
      width="100%"
      height="800px"
      src=""
      name="myIframe"
    />
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'IframeOrdini',
    components: {

    },
    data () {
      return {
        codsog: null,
        coddes: null,
        codcli: null,
      }
    },
    computed: {
      ...mapState(['auth']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      this.codsog = this.auth.userinfo.codsog
      this.coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      this.codcli = `${this.codsog}${this.coddes}`
      this.openWindowWithPost('https://swissflex.it/ordini/index.php', {
        username: this.codcli,
        password: this.auth.userinfo.plain_password,
      })
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      openWindowWithPost (url, data) {
        var form = document.createElement('form')
        form.target = 'myIframe'
        form.method = 'POST'
        form.action = url
        form.style.display = 'none'

        for (var key in data) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = key
          input.value = data[key]
          form.appendChild(input)
        }
        document.body.appendChild(form)
        form.submit()
        document.body.removeChild(form)
        // this.$router.back()
      },

    },

  }
</script>
